export { ReportReason, ReportReasonMap, ReportReasonList } from '@myrealtrip/messenger-core';
export type { LocalReportReason } from '@myrealtrip/messenger-core';
